export default __webpack_public_path__ + "static/media/shield.7a0525e8.svg";